import * as React from 'react';
import { css, html } from 'react-strict-dom';

import Text from './Text';

type Props = Readonly<{
  right?: React.ReactNode;
  children: React.ReactNode;
}>;

export default function PageHeading({ right, children }: Props) {
  return (
    <html.div style={styles.container}>
      <Text as="h1" style={styles.heading}>
        {children}
      </Text>
      {right}
    </html.div>
  );
}

const styles = css.create({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 25,
    marginInline: 0,
    alignItems: 'center',
  },
  heading: {
    color: '#333',
    fontSize: 28,
    fontWeight: '500',
    margin: 0,
  },
});
